import {SupplierService} from '@/common/api/supplier.service'
import {
    SUPPLIER_CREATE,
    SUPPLIER_EDIT,
    SUPPLIER_DELETE,
    SUPPLIER_GET,
    SUPPLIERS_GET,
    SUPPLIER_SEARCH, SUPPLIER_ACTIVE, SUPPLIER_INACTIVE
} from './actions/supplier.type.js'
import {
    SET_SUPPLIER,
    SET_SUPPLIERS,
    SUPPLIER_RESET,
    SET_SUPPLIER_PAGINATION,
    SET_SUPPLIER_ACTIVE,
    SUPPLIER_RESET_STATE
} from './mutations/supplier.type.js'

import {CHANGE_PROGRESS} from './mutations/mutations.type.js'

const initialState = () => {
    return {
        supplier: {
            name: "",
            cnpj: null,
            phone: "",
            representative: "",
            obs: "",
            address: ""
        },

        activePage: 1,
        totalPages: 1,

        supplierPagination: {
            search: "",
            itemsPerPage: 10,
            orderBy: "",
            sortDesc: false,
        },
        suppliers: {
            active: true,
            activePage: 1,
            totalPages: 1,
            totalItems: 1,
            items: []
        },

    }
}

export const state = initialState()

const getters = {
    supplier: state => {
        return state.supplier
    },
    suppliers: state => {
        return state.suppliers
    },
    supplierSearch: state => {
        return state.supplierSearch
    },
    supplierPagination: state => {
        return state.supplierPagination
    }

}

export const mutations = {
    [SET_SUPPLIER](state, data) {
        state.supplier = data
    },
    [SET_SUPPLIERS](state, data) {
        state.suppliers = data
    },
    [SET_SUPPLIER_PAGINATION](state, data) {
        state.suppliers.activePage = data.page
        state.supplierPagination.itemsPerPage = data.itemsPerPage
        state.supplierPagination.orderBy = data.orderBy
        state.supplierPagination.sortDesc = data.sortDesc
    },
    [SET_SUPPLIER_ACTIVE](state, active) {
        state.supplier.active = active
    },
    [SUPPLIER_RESET](state) {
        Object.assign(state.supplier, initialState().supplier)
    },
    [SUPPLIER_RESET_STATE](state) {
        Object.assign(state, initialState())
    },
}

export const actions = {
    async [SUPPLIERS_GET]({commit}) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await SupplierService.list()
        commit(SET_SUPPLIERS, data.items)
        commit(CHANGE_PROGRESS, false)
    },
    async [SUPPLIER_GET]({commit}, id) {
        commit(CHANGE_PROGRESS, true)
        const {data} = await SupplierService.get(id)
        commit(SET_SUPPLIER, data)
        commit(CHANGE_PROGRESS, false)
    },
    async [SUPPLIER_SEARCH]({commit, state}) {
        // commit(CHANGE_PROGRESS, true)
        const {data} = await SupplierService.search(
            state.suppliers.activePage,
            state.supplierPagination.itemsPerPage,
            state.suppliers.active,
            state.supplierPagination.search,
            state.supplierPagination.orderBy,
            state.supplierPagination.sortDesc)
        commit(SET_SUPPLIERS, data)
        // commit(CHANGE_PROGRESS, false)
    },
    [SUPPLIER_CREATE]({state}) {
        return SupplierService.create(state.supplier)
    },
    [SUPPLIER_EDIT]({state}) {
        return SupplierService.update("", state.supplier)
    },
    [SUPPLIER_ACTIVE](_, id) {
        return SupplierService.active(id)
    },
    [SUPPLIER_INACTIVE](_, id) {
        return SupplierService.inactive(id)
    },
    [SUPPLIER_DELETE]({state}) {
        return SupplierService.delete(state.supplier.id)
    },
    [SUPPLIER_RESET_STATE]({commit}) {
        commit(SUPPLIER_RESET_STATE)
    }
}
export default {
    state,
    actions,
    mutations,
    getters
}
